import { render, staticRenderFns } from "./list-urgence.vue?vue&type=template&id=401aeb84&scoped=true&"
import script from "./list-urgence.vue?vue&type=script&lang=ts&"
export * from "./list-urgence.vue?vue&type=script&lang=ts&"
import style0 from "./list-urgence.vue?vue&type=style&index=0&id=401aeb84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401aeb84",
  null
  
)

export default component.exports